module.exports = __webpack_public_path__ + "dash_20_app_assets/img/alldevices.ed726e26.png";